import * as GatewayServer from './server.ts';

export { GatewayServer };
export default GatewayServer.Factory;
